



















import { Component, Vue, Prop } from 'vue-property-decorator';
import SectionContainer from '@/components/Commons/SectionContainer.vue';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Loader from './Loader.vue';
import Broadcast from './Broadcast.vue';
import Joblisting from './Joblisting.vue';
import JoblistingMapView from './JobListingMapView/JoblistingMapView.vue';
import JobAlertUI from './JobAlertUI.vue';
import JobApplicationLink from './JobApplicationLink.vue';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import SearchboxWrapper from './SearchFilter/SearchboxWrapper.vue';
declare var window: any;

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'FindJobs',
  components: {
    SectionContainer,
    SearchboxWrapper,
    Jobseeker,
    Myreferrals,
    Broadcast,
    Joblisting,
    JoblistingMapView,
    Loader,
    JobAlertUI,
    JobApplicationLink,
  },
})
export default class FindJobs extends Vue {
  $wlToastr: any;
  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  beforeMount() {
    this.stopShowFindJobs && this.$router.push('login');
  }

  get canShowJobApplicationLink() {
    return (
      vxm.users.RequiredStepsInfo.requiredStepsMissing.length &&
      this.showJobApplicationLink &&
      this.isLoggedIn
    );
  }

  get showJobApplicationLink() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const submitApplication = vxm.configs.slideMenuSubSections(
        'FIND_JOBS',
        'SUBMIT_APPLICATION',
      );
      return submitApplication ? true : false
    }
    return vxm.jobs.BrandingInfo.SHOW_APPLICATION_LINK_IN_FIND_JOBS;
  }

  get showMapView() {
    return vxm.jobs.getMapViewMode;
  }

  async mounted() {
    // If the user opens FindJobs we turn off the redirection to GSU
    vxm.jobs.setSkipGuidedSignUpOnApplication(true);

    if (this.stopShowFindJobs) {
      return;
    }
    this.isLoggedIn && vxm.users.getProfileWizardStepInfo()
    /* If the user starts navigating and opens the FindJobs after logged in
     * we'll turn the New User flag + validation off
     */
  }

  get getJobAlertId() {
    return this.$route.query.jobalertid;
  }

  get stopShowFindJobs() {
    return (
      vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN') && !this.isLoggedIn
    );
  }
}
